import type { EntityAdapter } from '@ngrx/entity';
import type { Action } from '@ngrx/store';
import type {
  CompletedEntityState,
} from 'app/store/completed-entity-state/completed-entity-state';
import type { DocumentOutput } from 'core/http/project';
import { createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import {
  initialCompletedEntityState,
} from 'app/store/completed-entity-state/completed-entity-state';
import * as DocumentsActions from './documents.actions';

export interface DocumentsState extends CompletedEntityState<DocumentOutput> {}

const adapter: EntityAdapter<DocumentOutput> = createEntityAdapter<DocumentOutput>();

export const initialDocumentsState = adapter.getInitialState<DocumentsState>(initialCompletedEntityState);

const reducer = createReducer(
  initialDocumentsState,
  on(DocumentsActions.saveDocuments, (state, payload) => adapter.setAll(payload.documents, state)),
  on(DocumentsActions.markDocumentsLoaded, state => ({ ...state, loaded: true })),
  on(DocumentsActions.setLoading, (state, { value }) => ({ ...state, loading: value })),
  on(DocumentsActions.setError, (state, { value }) => ({ ...state, error: value })),
);

export function documentsReducer(state: DocumentsState | undefined, action: Action): DocumentsState {
  return reducer(state, action);
}

export const {
  selectAll,
  selectEntities,
} = adapter.getSelectors();
